export default __webpack_public_path__ + "static/media/1-5.88c342b8.jpg";